<template>
  <div class="card p-3 shadow">
    <h4 class="font-weight-bolder text-primary pb-3">بزرگترین سفارش</h4>
    <table class="table text-center" v-if="Object.keys(order).length > 0">
      <tbody>
      <tr>
        <th colspan="4"> {{ order.user.name }} {{ order.user.last_name }}</th>
      </tr>
      <tr>
        <td>قیمت</td>
        <td>{{ formatNumber(order.total_amount) }}</td>
      </tr>
      <tr>
        <td>تخفیف</td>
        <td>{{ formatNumber(order.offer_amount) }}</td>
      </tr>
      <tr>
        <td>هزینه ارسال</td>
        <td>{{ formatNumber(order.delivery_amount) }}</td>
      </tr>
      <tr>
        <td>قابل پرداخت</td>
        <td>{{ formatNumber(order.paying_amount) }}</td>
      </tr>
      <tr>
        <td>تاریخ پرداخت</td>
        <td dir="ltr">{{ dateConverter(order.transaction.updated_at, '/', true) }}</td>
      </tr>
      <tr class="text-center">
        <td colspan="4">
          <m-a class="btn btn-primary" :href="{name:'Factor',params:{orderId:order.id}}">
            مشاهده فاکتور
          </m-a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import {dateConverter, formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "StaticBiggestSell",
  data() {
    return {
      order: {},
    }
  },
  methods: {
    dateConverter,
    formatNumber,
    getBiggestSell() {
      this.$store.dispatch('Statistic/biggestSell').then(res => {
        this.order = res.data.data
      })
    },

  },
  async mounted() {
    await this.getBiggestSell()
  }
}
</script>


<style scoped>

</style>